<div>
  <h3 class="update-profile-subtitle">{{ "PROFILE.CHANGE_PASSWORD_SUBTITLE" | translate }}</h3>
  <p class="update-profile-description">{{ "PROFILE.CHANGE_PASSWORD_MESSAGE" | translate }}</p>
  <p class="update-profile-description">
    {{ "PROFILE.CHANGE_PASSWORD_MESSAGE_2" | translate }}
    <span class="form-highlight-text">podrska&#64;ulaznice.hr</span>.
  </p>

  <form class="user-form" [formGroup]="changePasswordForm" (ngSubmit)="changePassword()">
    <div class="user-form-input-container">
      <div class="user-form-input mt-5" [class.invalid]="changePasswordForm.get('oldPassword')!.touched && changePasswordForm.get('oldPassword')!.invalid">
        <label for="old-password" class="user-form-input-label"> {{ "PROFILE.CURRENT_PASSWORD" | translate }}</label>
        <input id="old-password" type="password" formControlName="oldPassword" placeholder=" "> 
      </div>

      <div class="user-form-input mt-3" [class.invalid]="changePasswordForm.get('newPassword')!.touched && changePasswordForm.get('newPassword')!.invalid">
        <label for="new-password" class="user-form-input-label">{{ "PROFILE.NEW_PASSWORD" | translate }}</label>
        <input id="new-password" type="password" formControlName="newPassword" placeholder=" "> 
      </div>

      <div class="user-form-input mt-3" [class.invalid]="changePasswordForm.get('newPasswordRepeated')!.touched && changePasswordForm.get('newPasswordRepeated')!.invalid">
        <label for="new-password-repeat" class="user-form-input-label">{{ "PROFILE.REPEAT_NEW_PASSWORD" | translate }}</label>
        <input id="new-password-repeat" type="password" formControlName="newPasswordRepeated" placeholder=" "> 
      </div>
    </div>

    <ng-container *ngIf="errorMessage || successMessage; else initialTemplate">
      <div class="text-center mt-3">
        <p class="error-message">{{ errorMessage }}</p>
        <p class="success-message">{{ successMessage }}</p>
      </div>
    </ng-container>
    <ng-template #initialTemplate>
      <span class="error-message hidden mt-3">-</span>
    </ng-template>


    <div class="flex flex-end mt-5">
      <button type="submit" class="btn btn-primary">{{ "PROFILE.SAVE" | translate }}</button>
    </div>
  </form>
</div>